module.exports = __webpack_public_path__ + "static/media/vip_4.178af76b.svg";